import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'notifications/',
  fetchPaginated (page) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}?limit=100&page=${page}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  markAllAsRead () {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}all`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteAll () {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}all`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  markAsRead (notificationId) {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}${notificationId}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  deleteNotification (notificationId) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}${notificationId}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}
